import PropTypes from 'prop-types'
import React from 'react'
import Modal from 'react-overlays/lib/Modal'
import Button from 'components/button'
import styles from './file_selector_modal.module.scss'

const convertMegabytes = byte => {
  return byte / 1048576
}

const FileSelectorModal = ({ isOpened, onClick, fileSizeLimit }) => {
  return (
    <Modal show={isOpened}>
      <div className={styles.modal}>
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.title}>{I18n.t('components.file_selector_modal.title')}</div>
          </div>
          <div className={styles.content}>
            <div className={styles.text}>
              {I18n.t('components.file_selector_modal.text.1', {
                size: convertMegabytes(fileSizeLimit)
              })}
            </div>
            <div className={styles.text}>{I18n.t('components.file_selector_modal.text.2')}</div>
          </div>
          <div className={styles.submit}>
            <Button className={styles.btnSubmit} intent="danger" onClick={onClick}>
              {I18n.t('components.file_selector_modal.button.close')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

FileSelectorModal.propTypes = {
  isOpened: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  fileSizeLimit: PropTypes.number.isRequired
}

export default FileSelectorModal
